<template>
  <component :is="showAdminNav ? 'admin-layout' : 'app-layout'" class="Error">
    <div class="mt-gr-double-6 sm:mt-gr-double-7">
      <div class="container text-center py-gr-8 lg:py-gr-9">
        <h1 class="font-black opacity-30 text-sm tracking-wider uppercase leading-gr-7">
          {{ title }}
        </h1>
        <div class="text-3xl leading-gr-7 mt-gr-5">{{ description }}</div>
        <button @click="goBack" class="link mt-gr-5 p-gr-5 text-lg">
          <i class="fa fa-arrow-left mr-gr-3"></i>Go Back
        </button>
      </div>
    </div>
  </component>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout';
  import AdminLayout from '@/Layouts/AdminLayout';

  export default {
    name: 'Error',

    props: {
      status: Number,
      showAdminNav: Boolean,
    },

    components: {
      AppLayout,
      AdminLayout,
    },

    computed: {
      title() {
        return {
          503: `503: Service Unavailable`,
          500: `500: Server Error`,
          404: `404: Page Not Found`,
          403: `403: Forbidden`,
        }[this.status];
      },

      description() {
        return {
          503: `Sorry, we are doing some maintenance. Please check back soon.`,
          500: `Whoops, something went wrong on our servers.`,
          404: `Sorry, the page you are looking for could not be found.`,
          403: `Sorry, you cannot access this page.`,
        }[this.status];
      },
    },

    methods: {
      goBack() {
        return window.history.back();
      },
    },
  };
</script>
